// Legacy defaults keep status displays usable while older APIs are being upgraded.
const defaults = {
  Ordering: { label: 'ส่งคำสั่งยา', color: '#6C757D', icon: 'file-text' },
  Preparing: { label: 'รอจัดยา', color: '#FFB64D', icon: 'clock' },
  Verifying: { label: 'รอตรวจยา', color: '#FF5370', icon: 'check-square' },
  Dispensing: { label: 'รอจ่ายยา', color: '#4099FF', icon: 'clock' },
  Completed: { label: 'จ่ายยาแล้ว', color: '#2ED8B6', icon: 'check' },
  Canceled: { label: 'ยกเลิกแล้ว', color: '#FF5370', icon: 'x' },
}
const aliases = { Preparation: 'Preparing', Verify: 'Verifying' }
export const getPrescriptionStatusName = (name) => aliases[name] || name

export const normalizePrescriptionStatusColor = (value) => {
  const hex = String(value || '').trim()
  return /^#?[0-9a-f]{6}$/i.test(hex)
    ? `#${hex.replace('#', '').toUpperCase()}`
    : null
}

export const getPrescriptionStatusDisplay = (status = {}) => {
  const name = getPrescriptionStatusName(status?.name)
  const fallback = defaults[name]
  const color =
    normalizePrescriptionStatusColor(status?.hexColor) ||
    fallback?.color ||
    '#6C757D'
  const channels = [1, 3, 5].map((start) => {
    const value = parseInt(color.slice(start, start + 2), 16) / 255
    return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4
  })
  const luminance =
    channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722
  return {
    label:
      status?.nameTh?.trim() ||
      fallback?.label ||
      status?.description ||
      status?.name ||
      '-',
    color,
    textColor: luminance > 0.179 ? '#000000' : '#FFFFFF',
    icon: fallback?.icon || 'info',
  }
}
